import * as React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  Grid,
  Switch,
} from "@mui/material";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { useState, useMemo } from "react";
import L from "leaflet";
import Navbar2 from "../Navbar/Navbar2";
import bactchingplant from "../Images/Machines/Batching plant.png";
import { green } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const COLORS = {
  primary: "#144FEE",
  white: "#FFFFFF",
  bg: "#F5F7FB",
  border: "#E3E8F0",
  text: "#0F172A",
  textSecondary: "#64748B",
};

/* ---------------- MACHINE DATA ---------------- */

/* ---------------- COMPONENT ---------------- */
export default function MachineListMap(props) {
  const [selected, setSelected] = useState(null);
  const [machineDetails, setMachineDetails] = useState([]);
  const [loading, setLoading] = React.useState(false);

  const navigate = useNavigate();

  const getAddressFromLatLng = async (lat, lng) => {
    try {
      const res = await axios.get(
        `https://nominatim.openstreetmap.org/reverse`,
        {
          params: {
            format: "json",
            lat: lat,
            lon: lng,
          },
        },
      );

      const address = res.data.address;

      return {
        city: address.city || address.town || address.village || "",
        state: address.state || "",
      };
    } catch (err) {
      console.log(err);
      return { city: "", state: "" };
    }
  };

  const getMachineDetails = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token"); // or sessionStorage

      const res = await axios.get(
        "https://iot-api.elantristechnologies.com/api/BatchingPlant/Get_MachineDetails",
        {
          headers: {
            Authorization: `Bearer ${token}`, // 👈 token header
            "Content-Type": "application/json",
          },
        },
      );

      if (res.data.status == "1") {
        const updatedData = await Promise.all(
          res.data.data.map(async (item, index) => {
            const addr = await getAddressFromLatLng(item.lat, item.lng);

            return {
              id: index + 1,
              type: item.prod_name,
              location: addr.city,
              state: addr.state,
              lat: item.lat,
              lng: item.lng,
              img: bactchingplant,
              sts: item.active == false ? "Noactive" : "Active",
              min: item.run_hrs,

              cust_code: item.cust_code,
              mac_id: item.mac_id,
              prod_id: item.prod_id,
              eqp_id: item.eqp_id,
              eqp_group_id: item.eqp_group_id,
              mac_type: item.mac_type,
              mac_sl: item.mac_sl,
              mac_name: item.mac_name,
              imei: item.imei,
              iot_type: item.iot_type,
              inst_date: item.inst_date,
              act_date: item.act_date,
              expiry_date: item.expiry_date,
            };
          }),
        );

        setMachineDetails(updatedData);

        // 👉 mac_id & mac_type only store in localStorage
        const macInfo = res.data.data.map((m) => ({
          mac_id: m.mac_id,
          mac_type: m.mac_type,
          prod_id: m.prod_id,
        }));

        localStorage.setItem("machineMacInfo", JSON.stringify(macInfo));
      } else {
        alert(res.data.msg);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getMachineDetails();
  }, []);

  /* -------- GROUP BY TYPE -------- */
  const groupedMachines = useMemo(() => {
    return machineDetails.reduce((acc, m) => {
      if (!acc[m.type]) acc[m.type] = [];
      acc[m.type].push(m);
      return acc;
    }, {});
  }, [machineDetails]); // ✅ fix

  /* -------- CUSTOM MAP ICON -------- */
  const createMachineIcon = (id, img) =>
    new L.DivIcon({
      html: `
        <div style="
          display:flex;
          flex-direction:column;
          align-items:center;
          transform:translate(-50%,-100%);
        ">
          <img src="${img}" style="width:32px;height:32px;" />
          <span style="
            margin-top:-4px;
            background:#144FEE;
            color:white;
            font-size:9px;
            font-weight:600;
            padding:2px 6px;
            border-radius:6px;
            white-space:nowrap;
            font-family:Poppins,sans-serif;
          ">
            ${id}
          </span>
        </div>
      `,
      className: "",
    });

  return (
    <div>
      <Box display='flex' height='92vh' bgcolor={COLORS.bg}>
        {/* ---------------- LEFT MAP ---------------- */}
        <Box flex={2}>
          <MapContainer
            center={[22.5937, 78.9629]}
            zoom={5}
            style={{ height: "100%", width: "100%" }}
          >
            <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />

            {machineDetails.map((m) => (
              <Marker
                key={m.id}
                position={[m.lat, m.lng]}
                icon={createMachineIcon(m.id, m.img)}
                eventHandlers={{
                  click: () => setSelected(m.id),
                }}
              >
                <Popup>
                  <Typography fontWeight={600} color={COLORS.primary}>
                    {m.id}
                  </Typography>
                  <Typography fontSize={13}>{m.type}</Typography>
                  <Typography fontSize={12} color={COLORS.textSecondary}>
                    {m.location}, {m.state}
                  </Typography>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </Box>

        {/* ---------------- RIGHT LIST ---------------- */}
        <Box
          flex={1}
          p={2}
          bgcolor={COLORS.white}
          sx={{ borderLeft: `1px solid ${COLORS.border}`, overflowY: "auto" }}
        >
          <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            <Grid>
              <Typography
                variant='subtitle2'
                sx={{
                  color: COLORS.textSecondary,
                  mb: 2,
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                LIST VIEW
              </Typography>
            </Grid>
            <Grid>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Switch
                  checked={props.machineList}
                  onChange={(e) => props.handleMachineView(false)}
                  size='small'
                  sx={{
                    width: 36,
                    height: 20,
                    padding: 0,

                    "& .MuiSwitch-switchBase": {
                      padding: 0.3,
                      transform: "translateX(0px)",
                    },

                    "& .MuiSwitch-thumb": {
                      width: 16,
                      height: 16,
                    },

                    "& .MuiSwitch-track": {
                      borderRadius: 20,
                      backgroundColor: "#d1d5db",
                      opacity: 1,
                    },

                    "& .MuiSwitch-switchBase.Mui-checked": {
                      transform: "translateX(16px)",
                      color: "#fff",
                    },

                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#0059ff",
                      opacity: 1,
                    },
                  }}
                />

                <Typography
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "0.7rem",
                  }}
                >
                  {props.machineList ? "Map" : "List"}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <List>
            {Object.entries(groupedMachines).map(([type, items]) => (
              <Box key={type} mb={2}>
                {/* TYPE HEADING */}
                <Typography
                  sx={{
                    fontSize: "0.8rem",
                    color: COLORS.textSecondary,
                    mb: 1,
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 600,
                  }}
                >
                  {type}
                </Typography>

                {/* ITEMS */}
                {items.map((m) => (
                  <ListItem
                    key={m.id}
                    onClick={() => {
                      setSelected(m.id);
                      navigate("/Dashboard");
                      sessionStorage.setItem("selectnav1", "Dashboard");
                    }}
                    sx={{
                      mb: 1,
                      borderRadius: 1,
                      cursor: "pointer",
                      border: `1px solid ${COLORS.border}`,
                      bgcolor: selected === m.id ? "#E8EDFF" : COLORS.white,
                      "&:hover": { bgcolor: "#E8EDFF" },
                    }}
                  >
                    <ListItemText
                      primary={
                        <Typography
                          fontWeight={600}
                          sx={{ fontFamily: "Poppins, sans-serif" }}
                        >
                          {m.mac_id} - {m.mac_type}
                        </Typography>
                      }
                      secondary={
                        <Grid display='flex' gap={1}>
                          <Typography
                            fontSize={11}
                            color={COLORS.textSecondary}
                            sx={{ fontFamily: "Poppins, sans-serif" }}
                          >
                            {m.location}
                          </Typography>
                          <Typography
                            fontSize={11}
                            color={COLORS.textSecondary}
                            sx={{ fontFamily: "Poppins, sans-serif" }}
                          >
                            {m.state}
                          </Typography>
                        </Grid>
                      }
                    />

                    <Grid
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      {m.sts == "active" ? (
                        <>
                          <Box
                            sx={{
                              width: 10,
                              height: 10,
                              borderRadius: "50%",
                              backgroundColor: "green",
                            }}
                          />

                          <Typography
                            fontSize={11}
                            sx={{
                              fontFamily: "Poppins, sans-serif",
                              color: "#2e2e2e",
                            }}
                          >
                            60m 3
                          </Typography>
                        </>
                      ) : (
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            backgroundColor: "red",
                          }}
                        />
                      )}
                    </Grid>

                    {/* <Chip
                      size='small'
                      label='Active'
                      sx={{
                        bgcolor: COLORS.primary,
                        color: COLORS.white,
                        fontSize: "0.7rem",
                      }}
                    /> */}
                  </ListItem>
                ))}
              </Box>
            ))}
          </List>
        </Box>
      </Box>
    </div>
  );
}
